import config from "config/config";
import { BlueInfoIcon } from "styles/icons";
import { ChakraVStack as VStack, ChakraHeading as Heading, ChakraBox as Box } from "@airhelp/react-ui-components";
import type { sbEditableProps } from "types/storyblok";

export interface InfoBoxProps {
  heading: string;
  text: JSX.Element | string;
  sbEditable?: sbEditableProps;
}
const imageUrl = `url('${config.staticUrl}/components/info-box-decoration-img.svg?updatedAt=1629364030143')`;

const InfoBox = ({ heading, text, sbEditable }: InfoBoxProps) => (
  <VStack
    bg="greyscale.200"
    borderRadius="xl"
    flexDir="column"
    p={6}
    spacing={4}
    align="left"
    bgImage={imageUrl}
    bgSize="contain"
    bgRepeat="no-repeat"
    bgPos="left 90% bottom -20px"
    {...sbEditable}
  >
    <BlueInfoIcon color="primary.500" w={8} h={8} />
    <Heading variant="h4" as="h4" fontWeight="400">
      {heading}
    </Heading>
    <Box>{text}</Box>
  </VStack>
);

export default InfoBox;
